export default {
    methods: {
        roundTo3(number) {
            return parseFloat(number).toFixed(3);
        },
        roundTo2(number) {
            return parseFloat(number).toFixed(2);
        }
    },
};
